import { action, observable } from 'mobx';

let obx = observable({
  paymentToken: {},
  submitPayment: action(function() {
    if(obx.afterPayment) {
      obx.afterPayment();
    }
  }),
  afterPayment: null,
  setAfterPayment: action(function(func) {
    obx.afterPayment = func;
  }),
  schedulingRuleInformation: []
});

export default obx;


// WEBPACK FOOTER //
// ./src/app/stores/PaymentStore.js